import { Component, Input, OnChanges, signal, TemplateRef, ViewChild } from '@angular/core';
import { MatMenuTrigger, MenuPositionX, MenuPositionY } from '@angular/material/menu';
import { IMPORTS } from './_imports';

@Component({
    selector: 'popover',
    templateUrl: './popover.component.html',
    styleUrl: './popover.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class PopoverComponent implements OnChanges {
    // #region [ViewChild]
    @ViewChild(MatMenuTrigger) private matMenuTrigger!: MatMenuTrigger;
    // #endregion

    // #region [signals]
    $disabled = signal(false);
    $xPosition = signal('after' as MenuPositionX);
    $yPosition = signal('below' as MenuPositionY);
    $popoverContent = signal(null as TemplateRef<unknown>);
    // #endregion

    // #region [Input/Output]
    @Input() _disabled: boolean;
    @Input() _xPosition: MenuPositionX = 'after';
    @Input() _yPosition: MenuPositionY = 'below';
    @Input() _popoverContent: TemplateRef<unknown>;
    // #endregion

    constructor() { }

    ngOnChanges() {
        this.$disabled.set(this._disabled);
        this.$xPosition.set(this._xPosition);
        this.$yPosition.set(this._yPosition);
        this.$popoverContent.set(this._popoverContent);
    }

    open() {
        this.matMenuTrigger?.openMenu();
    }

    close() {
        this.matMenuTrigger?.closeMenu();
    }
}
